import axios from "axios";
import { getApiRoute } from "src/services";
import { useMutation } from "@tanstack/react-query";

async function validateSubscription({ calendarId }) {
  await axios.post(
    getApiRoute("user", "VALIDATE_SUBSCRIPTION"),
    { calendarId },
    { withCredentials: true }
  );
}

export function useValidateSubscription() {
  return useMutation(validateSubscription);
}
